import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/directorio-de-areas-historico-mision-y-vision';

/**
 * GET all misiones y visiones
 * @returns {Promise<object[]>}
 */
export const getAllMisionesVisiones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Misiones visiones by directorio area ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */

export const getMisionVisionByDirectorioAreaID = async (id) => {
  try {
    const response = await API.get(`${baseURI}`, {
      params: { directorio_area: id },
    });
    return response.data.results;
  } catch (err) {
    onError(err);
  }
  return null;
};
/**
 * POST Mision vision
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const createMisionVision = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Mision vision
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const updateMisionVisionById = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Mision vision
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteMisionVision = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

const a = {

  directorio_area: {
    type: 'field',
    required: true,
    read_only: false,
    label: 'Directorio area',
    help_text: 'Fk a Directorio de área',
  },
  vision: {
    type: 'string',
    required: false,
    read_only: false,
    label: 'Vision',
    help_text: 'Visión',
    max_length: 1250,
  },
  mision: {
    type: 'string',
    required: false,
    read_only: false,
    label: 'Mision',
    help_text: 'Misión',
    max_length: 1250,
  },
  vigencia_final: {
    type: 'date',
    required: true,
    read_only: false,
    label: 'Vigencia final',
    help_text: 'Vigencia final.',
  },
};
